/**
 * Tiny, dependency-free Markdown to HTML converter.
 *
 * Supports just what the admin needs to write Obchodní podmínky:
 *  - # H1, ## H2, ### H3
 *  - **bold**, *italic*
 *  - bullet lists (- or *) and numbered lists (1.)
 *  - links [text](url)
 *  - paragraphs (blank line separated)
 *  - horizontal rule ---
 *
 * Output is escaped first to avoid script injection from the admin textarea.
 */

function escapeHtml(s) {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function inline(text) {
  // links [text](url) – allow http(s) only
  text = text.replace(/\[([^\]]+)\]\(((?:https?:|mailto:)[^)\s]+)\)/g, (_, t, u) => {
    return `<a href="${u}" target="_blank" rel="noopener noreferrer">${t}</a>`;
  });
  // **bold**
  text = text.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  // *italic*
  text = text.replace(/(^|\s)\*([^*\s][^*]*)\*(?=\s|$|[.,;:!?])/g, '$1<em>$2</em>');
  return text;
}

export function renderMarkdown(src) {
  if (!src) return '';
  const lines = escapeHtml(src).split(/\r?\n/);
  const html = [];
  let inUl = false;
  let inOl = false;

  const closeLists = () => {
    if (inUl) { html.push('</ul>'); inUl = false; }
    if (inOl) { html.push('</ol>'); inOl = false; }
  };

  for (let raw of lines) {
    const line = raw.trimEnd();
    if (!line.trim()) {
      closeLists();
      continue;
    }

    // Headings
    let m = line.match(/^(#{1,3})\s+(.*)$/);
    if (m) {
      closeLists();
      const lvl = m[1].length;
      html.push(`<h${lvl}>${inline(m[2])}</h${lvl}>`);
      continue;
    }

    // Horizontal rule
    if (/^---+\s*$/.test(line)) {
      closeLists();
      html.push('<hr/>');
      continue;
    }

    // Unordered list
    m = line.match(/^\s*[-*]\s+(.*)$/);
    if (m) {
      if (!inUl) { closeLists(); html.push('<ul>'); inUl = true; }
      html.push(`<li>${inline(m[1])}</li>`);
      continue;
    }

    // Ordered list (e.g. "1.1 Foo" or "1. Foo")
    m = line.match(/^\s*\d+(?:\.\d+)*\.\s+(.*)$/);
    if (m) {
      // Numbered with sublevels we keep as paragraph – they read better that way
      // for legal docs ("1.1 Some clause").
      closeLists();
      // Preserve the leading number explicitly so it's visible.
      const numMatch = line.match(/^\s*(\d+(?:\.\d+)*)\.\s+(.*)$/);
      html.push(`<p><strong>${numMatch[1]}.</strong> ${inline(numMatch[2])}</p>`);
      continue;
    }

    // Regular paragraph
    closeLists();
    html.push(`<p>${inline(line)}</p>`);
  }
  closeLists();
  return html.join('\n');
}

export default renderMarkdown;
